export default __webpack_public_path__ + "static/media/2insta.6b26ed2e.jpg";